import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import RecordTags from '../RecordTags'
import FormController from '../form/FormController'

@observer
class ClientEdit extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
    }

    async componentDidUpdate(prevProps) {
        const { showModal } = this.props
        const {
            clientId, clientStore, handleCloseModal, role,
        } = this.props

        if (showModal && !prevProps.showModal) {
            if (!clientStore.clientEditAccess(clientId, role)) {
                handleCloseModal()
                // this.appStore.addNotification(null, 'Access denied', 'error')
                return
            }
            await clientStore.initClient(clientId, handleCloseModal)
        }
    }

    isValid = (client) => Object.keys(this.fields)
        .map((key) => this.fields[key]({
            value: client[key],
            name: key,
        }, true))
        .every((valid) => valid)

    handleSave = async () => {
        const { clientStore: { client, saveClient }, clientId, handleCloseModal } = this.props

        if (!this.isValid(client)) return

        await saveClient(clientId, handleCloseModal)
    }

    renderButtons = () => {
        const { handleCloseModal } = this.props
        return (
            <div className="form-button-wrapper">
                <Button
                    label={i18n.t('close')}
                    icon=""
                    cssClass="regular tertiary"
                    onClick={handleCloseModal}
                />
                <Button
                    label={i18n.t('save')}
                    icon="fa-light fa-floppy-disk"
                    cssClass="regular primary"
                    onClick={this.handleSave}
                />
            </div>
        )
    }

    render() {
        const {
            showModal, handleCloseModal, clientStore, clientId,
        } = this.props

        return (
            <Modal show={showModal} onClose={handleCloseModal} loading={clientStore.formLoading}>
                <div className="form-header">
                    <h2>{clientId !== 0 ? 'Edit client' : 'New client'}</h2>
                    <p className="desc">
                        {clientId !== 0 ? 'Edit your client details below' : 'Enter your new client details below'}
                    </p>
                </div>
                <FormController
                    fields={this.fields}
                    formFields={clientStore.formFields}
                    setField={clientStore.setField}
                />
                <RecordTags
                    values={clientStore.recordTags}
                    availableTags={clientStore.availableTags}
                    onBlur={clientStore.setTag}
                    register={this.register}
                    unregister={this.unregister}
                />
                {this.renderButtons()}
            </Modal>
        )
    }
}

export default ClientEdit
